import { gql } from '@apollo/client';
import { ActivityFragment, SourceFragment, LinkFragment } from './fragments';

export default isPreviewMode => gql`
  ${ActivityFragment}
  ${SourceFragment}
  ${LinkFragment}
  query Landing($slug: String!, $locale: String!) {
    landingCollection(where: { slug: $slug }, limit: 1, locale: $locale, preview:${isPreviewMode}) {
      items {
        sys {
          id
        }
        title
        slug
        introTitle
        pageText
        context
        optionalSections
        listSortLogic
        heroStyle
        heroGraphics
        primaryColor
        fontColor
        introVideo {
          url
        }
        userTerm
        client {
          slug
          name
          logoReverse {
            url
          }
          shortName
          metadata
          __typename
        }
        siteImagesCollection {
          items {
            title
            splashLarge {
              url
            }
            splashMedium {
              url
            }
            splashSmall {
              url
            }
            fontColor
            altText
            isTransparent
          }
        }
        audienceTypeCollection {
          items {
            sys {
              id
            }
            name
            reviewStatus
          }
        }
        intro {
          json
        }
        heroCta {
          json
        }
        heroFooter {
          json
        }
        introMedia {
          url
        }
        topTopicsCollection {
          items {
            title
            slug
            reviewStatus
            type
            description
            publicationDate
            sys {
              id
            }
            image {
              url
            }
          }
        }
        clientResourcesCollection {
          items {
            ...SourceFields
            ...ActivityFields
            ...LinkFields
          }
        }
        listsCollection {
          items {
            sys {
              id
            }
          }
        }
      }
    }
  }
`;
